import { css } from "@emotion/react";

export const card = css`
  display: grid;
  align-items: center;
  column-gap: 8px;
  row-gap: 8px;
  grid-template:
    "icon title" 32px
    "logo description" 1fr /
    32px 1fr;
  @media (min-width: 600px) {
    grid-template:
      "icon title" 48px
      "logo description" 1fr /
      48px 1fr;
    row-gap: 4px;
  }
`;

export const icon = css`
  grid-area: icon;
`;

export const title = css`
  grid-area: title;
  font-size: 14px;
  line-height: 16.8px;
  font-weight: 600;
`;

export const description = css`
  grid-area: description;
  font-size: 12px;
  font-weight: 300;
  line-height: 19.2px;
  align-self: start;
`;

export const logo = css`
  grid-area: logo;
  justify-self: center;
  align-self: start;
  max-width: 24px;
  @media (min-width: 600px) {
    max-width: 32px;
  }
`;
